export const permissionsConstants = {
    MANAGE_USER: "ROLE_MANAGE_USERS",
    VIEW_USERS: "ROLE_VIEW_USERS",
    VIEW_ROLES: "ROLE_VIEW_ROLES",
    CREATE_DISBURSEMENT: "ROLE_INITIATE_DISBURSEMENT",
    VIEW_INSTITUTIONS: "ROLE_VIEW_INSTITUTION",
    MANAGE_INSTITUTIONS: "ROLE_MANAGE_INSTITUTION",
    VIEW_DISBURSEMENT: "ROLE_VIEW_DISBURSEMENT",
    ACTIONS_DISBURSEMENT: "ROLE_ACTION_DISBURSEMENT",
    EDIT_DISBURSEMENT: "ROLE_EDIT_DISBURSEMENT",
    VIEW_ISW_ALL_DISBURSEMENT: "ROLE_VIEW_ALL_DISBURSEMENT",
    TEST: "ROLE_TEST",
};

export const createPermissions = () => {
    const permissions = [];
    for (let permission in permissionsConstants) {
        permissions.push(permissionsConstants[permission]);
    }
    return permissions;
};

export const permissions = createPermissions();
